var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"camion puiformheader"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('pui-field',{attrs:{"label":this.$t('vtccamiones.matricula'),"value":_vm.getMatricula}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }